import { render, staticRenderFns } from "./AdminProjektinfos.vue?vue&type=template&id=1c065236&scoped=true&"
import script from "./AdminProjektinfos.vue?vue&type=script&lang=js&"
export * from "./AdminProjektinfos.vue?vue&type=script&lang=js&"
import style0 from "./AdminProjektinfos.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AdminProjektinfos.vue?vue&type=style&index=1&id=1c065236&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c065236",
  null
  
)

export default component.exports